import { createContext } from 'react';
import type { UseThemeResult } from './useTheme';

/**
 * Theme context. Undefined by default so `useThemeContext` throws when used
 * outside {@link ThemeProvider}, catching wiring mistakes early.
 */
export const ThemeContext = createContext<UseThemeResult | undefined>(undefined);
